import styled from '@emotion/styled';
import { DatesWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';

interface MarketFiltersStyleTypes {
    isSelected?: boolean;
}
export const ColumnWrapper = styled('div', { label: 'ColumnWrapper' })`
    flex: 1 1 360px;
    padding: 0 20px;
    border-right: 1px solid #ccc;

    :last-of-type {
        border-right: none;
    }
`;

export const FiltersColumnWrapper = styled(ColumnWrapper, { label: 'FiltersColumnWrapper' })`
     max-width: 340px;
`;

export const ColumnsWrapper = styled('div', { label: 'ColumnsWrapper' })`
    display: flex;
    width: 1100px;
`;

export const BasicMarketItemWrapper = styled('div', { label: 'BasicMarketItemWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 6px 12px;
    background-color: #eeeeee;
    border: 1px solid #bebebe;
`;

export const BasicMarketItemSelectFilter = styled('div', { label: 'BasicMarketItemSelectFilter' })`
    width: 154px;
    position: absolute;
    top: 20px;
    background-color: #fff;
    right: 0;
    z-index: 1;
    cursor: pointer;
`;

export const MarketsForFilterItemContent = styled('div', { label: 'MarketsForFilterItemContent' })`
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 260px;
    padding: 8px 0;
`;

export const MarketName = styled('div', { label: 'MarketName' })<MarketFiltersStyleTypes>`
    opacity: ${({ isSelected }): string => isSelected === true ? '.3' : '1'};
    display: flex;
    align-items: center;
    flex: 1 1 70%;
    font-size: 14px;
    padding: 0 13px;
`;

export const FilterItem = styled('div', { label: 'FilterItem' })<MarketFiltersStyleTypes>`
    display: inline-flex;
    justify-content: space-between;
    width: 250px;
    padding: 4px;
    min-width: 60%;
    margin: 4px 0;
    cursor: pointer;
    font-size: 14px;
`;
export const FilterList = styled('ul', { label: 'FilterList' })`
    position: relative;
    padding: 0;
    list-style: none;
    max-height: 500px;
    overflow-y: auto;
`;

export const FilterListItem = styled('li', { label: 'FilterListItem' })<{isSelected?: boolean, isDragged?: boolean}>`
    background-color: ${({isSelected}): string => isSelected === true ? '#dcddde' : '#eeeeee'};
    border: 1px solid #bebebe;
    z-index: ${({isDragged}) => isDragged ? '10001' : 'inherit'};
`;

export const DraggableButton = styled('button', { label: 'DraggableButton' })`
    display: inline-block;
    transform: translateY(3px);
    background: transparent;
    border: 0;
`;

export const ActionButton = styled('div', { label: 'ActionButton' })`
    display: flex;
    align-items: center;
    width: 20px;
    cursor: pointer;
`;

export const ButtonWrapper = styled('div', { label: 'ButtonWrapper' })`
    display: flex;
    align-items: center;
    flex: 0 0 20px;
`;

export const IconWrapper = styled('div', { label: 'IconWrapper' })`
    display: inline-block;
`;

export const FiltersButton = styled('div', { label: 'FiltersButton' })`
    margin-left: 10px;
    cursor: pointer;
    flex: 0 0 20px;
`;

export const FilterElem = styled('label', { label: 'FilterElem' })<MarketFiltersStyleTypes>`
    display: flex;
    justify-content: space-between;
    font-weight: ${({ isSelected }): string => isSelected === true ? 'bold' : 'normal'};
    padding: 2px 8px;
    border-bottom: 1px solid #bebebe;
    cursor: pointer;
    :hover {
        background-color: #ccc;
    }
`;

export const DatePickerWrapper = styled(DatesWrapper, { label: 'DatePickerWrapper' })`
    width: 50%;
`;

export const ColumnHeader = styled('h2', { label: 'ColumnHeader' })`
    font-size: 14px;
    font-weight: 600;
`;

export const AddNewFilterWrapper = styled('div', { label: 'AddNewFilterWrapper' })`
    margin-top: 40px;
`;

export const MarketFilterButton = styled('button', { label: 'MarketFilterButton' })`
    border: 0;
    background-color: #bbb;
    color: #fff;
    cursor: pointer;
    padding: 3px 5px;
`;

export const ResetFiltersButton = styled(MarketFilterButton, { label: 'ResetFiltersButton' })`
    background-color: #c00;
    margin-top: 15px;
    text-transform: uppercase;
`;

export const ResetFilterDesc = styled('p', { label: 'ResetFilterDesc' })`
    margin: 0;
    line-height: 1;
`;

export const Note = styled('div', { label: 'Note' })`
    background-color: #000;
    color: #fff;
    padding: 9px 12px;
    font-size: 14px;
`;
